import React from "react";
import { Redirect, maintenanceMode } from "../components/Utilities";
import AvailablePrintsList from "../components/Prints/AvailablePrintsList";

interface Props {
  Title: string;
  MaxRows: number;
  Params?: any;
}

interface State {
  data: any;
  mcode: string;
  isMaintenanceMode: boolean;
}

class AvailablePrints extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
      mcode: "",
      isMaintenanceMode: false,
    };
  }

  componentDidMount(): void {
    const { mcode } = this.props.Params;
    let mode: boolean = maintenanceMode(mcode);
    this.setState({ isMaintenanceMode: mode });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <AvailablePrintsList maxRows={this.props.MaxRows} />
            {this.state.isMaintenanceMode && <Redirect path="/Maintenance" />}
          </div>
        </div>
      </div>
    );
  }
}

export default AvailablePrints;
